import { render, staticRenderFns } from "./StatusUpdateForm.vue?vue&type=template&id=447d523a&scoped=true&"
import script from "./StatusUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StatusUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d523a",
  null
  
)

export default component.exports